module.exports = __webpack_public_path__ + "static/media/YF16_0.2f4029f9.jpg";